import _ from 'lodash';

const getters = {
  suppliersByShopId: (state) => state.suppliers,
  suppliersName: (state) => _.values(_.mapValues(state.suppliers, 'name')),
  franco: (state, supplier) => state
    .suppliers
    .find((s) => s.name === supplier)
    .franco,
};
export default getters;
